var Vendd = (function (Vendd) {
    'use strict';


    Vendd.HandleItemStatistics = function () {

        var itemStatisticsDataArray = [];

        $('.x-control[data-manipulate-stats="true"]').each(function (i, control) {

            var $control = $(control);
            var itemId = $control.data('stats-itemid');
            var action = $control.data('stats-action');
            var data = { ItemId: itemId, Action: action };

            if ($.inArray(data, itemStatisticsDataArray) == -1)
                itemStatisticsDataArray.push(data);
        });

        if (itemStatisticsDataArray.length > 0) {
            var options = {
                url: 'StatsService.svc/ManipulateItemStatistics',
                data:
                {
                    data: itemStatisticsDataArray
                },
                onSuccess: onSuccess,
                onFailure: onFailure
            };
            Vendd.Service.call(options);
        }

        function onSuccess(response) {
          
        }

        function onFailure(response) {
          
        }
    };

    Vendd.HandleProductStatistics = function () {

        var productStatisticsDataArray = [];

        $('.x-control[data-manipulate-stats="true"]').each(function (i, control) {

            var $control = $(control);
            var productId = $control.data('stats-productid');
            var action = $control.data('stats-action');
            var data = { SkuId: productId, Action: action };

            if ($.inArray(data, productStatisticsDataArray) == -1)
                productStatisticsDataArray.push(data);
        });

        if (productStatisticsDataArray.length > 0) {
            var options = {
                url: 'StatsService.svc/ManipulateProductStatistics',
                data:
                {
                    data: productStatisticsDataArray
                },
                onSuccess: onSuccess,
                onFailure: onFailure
            };
            Vendd.Service.call(options);
        }

        function onSuccess(response) {

        }

        function onFailure(response) {

        }
    };


    return Vendd;

})(Vendd || {});